import React from 'react';
import { motion } from 'framer-motion';
import { SectionLabel, SectionHeading } from './ui/UI';
const questions = ['How could we be compromised?', 'Which path matters most?', 'What should we fix first?', 'Did the fix work?', 'What proof can we share?'];
export function Positioning() {
  return <section className="relative w-full py-32 border-t border-white/5" data-id="element-655">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-656">
        <SectionLabel number="01" label="Positioning" className="mb-8" data-id="element-657" />

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16" data-id="element-658">
          {/* Left column */}
          <div className="lg:col-span-5" data-id="element-659">
            <SectionHeading size="lg" className="mb-8" data-id="element-660">
              The self-serve validation layer for modern security.
            </SectionHeading>
            <p className="text-lg text-white/60 leading-relaxed mb-6" data-id="element-661">
              Periscan is not another vulnerability scanner.
            </p>
            <p className="text-lg text-white/60 leading-relaxed" data-id="element-662">
              It is a continuous security validation platform that answers the
              questions security teams, founders, auditors, insurers, customers,
              and boards actually ask.
            </p>
          </div>

          {/* Right column: Questions */}
          <div className="lg:col-span-7 lg:pl-12 lg:border-l border-white/5" data-id="element-663">
            <p className="font-mono text-xs uppercase tracking-widest text-white/40 mb-8" data-id="element-664">
              The Questions That Matter
            </p>
            <div className="space-y-0" data-id="element-665">
              {questions.map((q, i) => <motion.div key={i} initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true,
              margin: '-50px'
            }} transition={{
              duration: 0.5,
              delay: i * 0.08
            }} className="group flex items-baseline gap-6 py-5 border-b border-white/5" data-id="element-666">
                  <span className="font-mono text-xs text-[#1a8fd4]/60 tracking-widest" data-id="element-667">
                    Q.{String(i + 1).padStart(2, '0')}
                  </span>
                  <span className="text-2xl md:text-3xl font-medium text-white group-hover:text-[#1a8fd4] transition-colors" data-id="element-668">
                    {q}
                  </span>
                </motion.div>)}
            </div>
            <p className="mt-8 text-lg text-white/70 leading-relaxed" data-id="element-669">
              Periscan turns fragmented security signals into validated paths,
              clear remediation, and reusable proof.
            </p>
          </div>
        </div>
      </div>
    </section>;
}